import { Button, Grid, GridColumn, GridRow, Modal } from '@bp/ui-components';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getWarningTypeTranslation } from '../../../../utils/getWarningTypeTranslation';
import { useTeachingBlockStore } from '../../Contexts/TeachingBlockContext';
import styles from './ConflictModal.module.scss';

export const ConflictModal: FC = observer(() => {
  const { t } = useTranslation();

  const store = useTeachingBlockStore();

  const conflicts = store.conflictModal.conflicts;

  return (
    <Modal
      className={styles['conflict-modal']}
      width='s'
      isOpen={store.conflictModal.isOpen ?? false}
      onRequestClose={() => store.abortConflict()}
      title={t('teachingBlock.conflict.found', { count: conflicts?.length ?? 0 })}
      hideCloseButton
      shouldCloseOnEsc={false}
      shouldCloseOnOverlayClick={false}
      parent={document.fullscreenElement ? document.getElementById('teaching-block-grid') : null}
    >
      <Grid>
        {conflicts && conflicts.length > 0 && (
          <GridRow headline={t('common.conflict', { count: conflicts.length })}>
            <GridColumn width={12}>
              <div className={styles.conflicts}>
                {conflicts.map((conflict) => {
                  return conflict.data?.map((data) => {
                    const conflictText = `${getWarningTypeTranslation(conflict.type)} (${data.name})`;
                    return (
                      <div className={styles.conflict} key={data.uuid}>
                        {conflictText}
                      </div>
                    );
                  });
                })}
              </div>
            </GridColumn>
          </GridRow>
        )}

        <GridRow>
          <GridColumn width={12}>
            <div className={styles.actions}>
              <Button className='mr-3' hierarchy='secondary' onClick={() => store.ignoreConflict()}>
                {t('teachingBlock.conflict.ignore')}
              </Button>
              <Button className='mr-3' hierarchy='secondary' disabled>
                {t('teachingBlock.conflict.swap')}
              </Button>
              <Button hierarchy='primary' onClick={() => store.abortConflict()}>
                {t('teachingBlock.conflict.abort')}
              </Button>
            </div>
          </GridColumn>
        </GridRow>
      </Grid>
    </Modal>
  );
});
